module.exports = __webpack_public_path__ + "img/live1.ec544e5e.png";